import React, { PureComponent } from 'react';
import {
  AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Legend, Label
} from 'recharts';
import { __ } from '../lib/I18n';
import { percent } from '../lib/Util';

export default class Chart extends PureComponent {
  constructor(props) {
    super(props);
    this.state = { windowWidth: window.innerWidth };
  }

  componentDidMount() {
    this.setState({ windowWidth: window.innerWidth });
    window.addEventListener('resize', () => this.setState({ windowWidth: window.innerWidth }));
  }

  render() {
    const {
      data, labels, yMaxValue, numberOfStudents
    } = this.props;
    const { windowWidth } = this.state;

    return (
      <ResponsiveContainer>
        <AreaChart
          data={data}
          margin={{ right: 40 }}
        >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis
            dataKey="date"
            interval={windowWidth < 400 ? 1 : 0}
            dy={7}
            tick={{ fontSize: 12 }}
            tickFormatter={(tick) => {
              if (tick === 'auto') return 0;
              return tick;
            }}
          />
          <XAxis
            dataKey="numberAnswered"
            interval={windowWidth < 400 ? 1 : 0}
            xAxisId={1}
            dy={-8}
            tickLine={false}
            axisLine={false}
            tick={{ fontSize: 10 }}
            tickFormatter={tick => __('%s respondeu', percent(tick, numberOfStudents))}
            label={(
              <Label style={{ transform: 'translateY(12px)' }} value={__('Data da enquete')} />
            )}
          />
          <YAxis
            verticalAlign
            domain={[yMaxValue, yMaxValue]}
            allowDecimals={false}
            width={75}
            tickFormatter={tick => tick.toFixed(0)}
          >
            <Label value={__('Número de registros')} angle={-90} />
          </YAxis>
          <Tooltip content={({ active, payload }) => {
            if (active) {
              return (
                <div style={{ backgroundColor: 'rgba(255,255,255,.9)', padding: '12px', border: 'solid 1px rgba(0,0,0,0.2)' }}>
                  {
                    payload && payload.length
                      ? payload.slice(0).reverse().map((item, index) => (
                        <p key={index} className="label">{`${item.name}: ${item.value}`}</p>
                      )) : null
                  }
                </div>
              );
            }
            return null;
          }}
          />
          {
            labels.map((label, index) => (
              <Area
                animationBegin={0}
                animationDuration={150}
                key={index}
                type="monotone"
                dataKey={label.label}
                stackId="1"
                stroke={label.color}
                fill={label.color}
              />
            ))
          }

          <Legend
            align="center"
            verticalAlign="bottom"
            iconType="square"
            formatter={(value, entry) => {
              const text = entry.dataKey;
              return (
                <span className="chart-area-legend">{text}</span>
              );
            }}
            wrapperStyle={{ paddingTop: 10 }}
          />
        </AreaChart>
      </ResponsiveContainer>
    );
  }
}
